export function formatCardNumber(number: string) {
  return number.replace(/\s/g, '').replace(/(\d{4})(?=\d)/g, '$1 ');
}
